package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.Availability
import com.evoapps.evoshift.domain.repository.AvailabilityRepository

class GetAvailabilityUseCase(
    private val availabilityRepository: AvailabilityRepository
) {
    suspend operator fun invoke(
        userId: String,
        workplaceId: String,
        month: String
    ): Result<Availability> {
        return availabilityRepository.getAvailability(userId, workplaceId, month)
    }
}